"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconHomeCharging = function IconHomeCharging(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "m23.943 26.83 8.59 1.372a3.1 3.1 0 0 1 1.925 1.106l.126.166c.443.628.636 1.395.547 2.153l-.032.206-.858 4.628a3.1 3.1 0 0 1-2.864 2.534L31.19 39h-3.326a5 5 0 0 1-4.894 4 5 5 0 0 1-4.893-4H6.99v-2h11.087a5 5 0 0 1 4.893-4 5 5 0 0 1 4.894 4h3.328a1.1 1.1 0 0 0 1.055-.784l.03-.119.858-4.63a1.1 1.1 0 0 0-.789-1.262l-.125-.027-9.206-1.47-8.503-8.114 1.377-1.448zM22.971 35a3 3 0 0 0 0 6 3 3 0 0 0 2.997-3c0-1.657-1.342-3-2.997-3m0 1.5a1.5 1.5 0 1 1-.002 2.998 1.5 1.5 0 0 1 .002-2.998m0 1a.5.5 0 1 0 .002 1 .5.5 0 0 0-.002-1m-7.99-1.5h-3.995v-1h3.995zm30.962-20.414V33h-1.998V16.415l-8.988-9-8.99 8.999V19h-1.996v-3.414l10.986-11zM15.107 6.528l-1.861 1.856 1.339 1.34 1.829-1.822 1.41 1.416-1.826 1.82 1.404 1.408-2.52 2.523a5 5 0 0 1-3.532 1.465 5 5 0 0 1-2.41-.625 2.64 2.64 0 0 0 .343 2.91l.143.153-.707.707.708-.706 4.125 4.141-.011.01a3.913 3.913 0 0 1-2.765 6.68c-.963 0-1.89-.355-2.603-.995l-.16-.153 1.414-1.412a1.906 1.906 0 0 0 2.702-.002 1.91 1.91 0 0 0 .113-2.58l-.113-.124.656-.658-.648.646-4.125-4.14a4.64 4.64 0 0 1-.615-5.8 5 5 0 0 1 .422-6.588l2.523-2.524 1.492 1.495 1.863-1.857zM9.426 27.244l-1.414 1.412-5.953-5.97 1.414-1.413zM40.95 24h-4.994v-7h4.994zm-3.995-1h2.996v-5h-2.996zM9.23 9.413a3.003 3.003 0 0 0-.02 4.223l.144.136a2.995 2.995 0 0 0 4.114-.117l1.108-1.11-4.237-4.243z"
  })));
};

export { IconHomeCharging, IconHomeCharging as default };
